import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'ka' : 'en');
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 text-neutral-600 hover:text-neutral-900 transition-colors duration-200 px-3 py-2 rounded-lg hover:bg-neutral-100 group"
      title={`Switch to ${language === 'en' ? 'Georgian' : 'English'}`}
    >
      <Globe className="h-4 w-4 group-hover:rotate-12 transition-transform duration-200" />
      <span className="text-sm font-medium uppercase">{language === 'en' ? 'KA' : 'EN'}</span>
    </button>
  );
};

export default LanguageSwitcher;
